import type { AppRouteMeta } from '@/routing/route-meta';
import {
  STAFF_SECTIONS_PERMISSION,
  type OrganizationSettingsSection,
} from './organizationSettingsSections';

/**
 * Route options that put a section in the main sidebar when it declares
 * `sidebarNav`: the nav entry plus an access gate mirroring the section's
 * own (Gently-only → admin or Update OrganizationSettings, feature flag, module, permissions), so the
 * shortcut and the section agree on who sees it. Spread into the generated
 * section route; empty for sections without a shortcut.
 */
export function sectionRouteNavOptions(
  section: OrganizationSettingsSection,
): { staticData: { app: AppRouteMeta } } | Record<string, never> {
  if (!section.sidebarNav) return {};
  const Icon = section.icon;
  const permissionsAnyOf = section.requiredPermission
    ? [section.requiredPermission]
    : section.requiredAnyPermission
      ? [...section.requiredAnyPermission]
      : undefined;
  return {
    staticData: {
      app: {
        nav: {
          label: section.sidebarNav.label,
          icon: <Icon className="h-4 w-4" weight="fill" />,
          group: section.sidebarNav.group,
          order: section.sidebarNav.order,
        },
        access: {
          ...(section.gentlyOnly
            ? { adminOrPermission: STAFF_SECTIONS_PERMISSION }
            : {}),
          ...(section.featureFlag ? { featureFlag: section.featureFlag } : {}),
          ...(section.hiddenWhenFeatureFlag
            ? { hiddenWhenFeatureFlag: section.hiddenWhenFeatureFlag }
            : {}),
          ...(section.requiredModule
            ? { modulesAnyOf: [section.requiredModule] }
            : {}),
          ...(permissionsAnyOf ? { permissionsAnyOf } : {}),
        },
      },
    },
  };
}
